import { render, staticRenderFns } from "./VxCheckbox.vue?vue&type=template&id=4ef22145&"
import script from "./VxCheckbox.vue?vue&type=script&lang=js&"
export * from "./VxCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports